import React from 'react';
import styled from 'styled-components';
import { UiFlex, UiImage, UiButtonProps } from '@open-stack/ui';
import logoBambora from './logo-bambora.png';
import logoVipps from './logo-vipps.png';
import logoMobilePay from './logo-mobile-pay.png';
import { PaymentProvider } from '../../../../XV2';
import { XButton } from '../../../x/button/XButton';
import logoVisa from './logo-visa.jpg';
import logoMastercard from './logo-mastercard.png';

const Wrapper = styled(XButton)`
    background-color: var(--ui-color-white) !important;
`;

interface Props extends UiButtonProps {
    provider: PaymentProvider;
}

export function ProviderBamboraButton({ provider, ...rest }: Props) {
    rest.size = rest.size ?? 2;

    const Component = Wrapper as any;

    const imageProps = {
        [PaymentProvider.BAMBORA]: {
            src: logoBambora,
            height: 48,
        },
        [PaymentProvider.BAMBORA_VIPPS]: {
            src: logoVipps,
            height: 24,
        },
        [PaymentProvider.BAMBORA_MOBILE_PAY]: {
            src: logoMobilePay,
            height: 32,
        },
    }[provider];

    if (provider === PaymentProvider.BAMBORA) {
        return (
            <Component {...rest} cta>
                <UiFlex>
                    <UiImage src={logoVisa} height={32} />
                    <UiImage src={logoMastercard} height={48} />
                </UiFlex>
            </Component>
        );
    }

    return (
        <Component {...rest} cta>
            <UiFlex>
                <UiImage {...imageProps} />
            </UiFlex>
        </Component>
    );
}
